import type { User } from "@/context/UserProvider";

export function userHasTrustSuite(user: User | null | undefined): boolean {
  return Boolean(user?.trust_suite);
}
